// Translations for BE1 — AZ (default), EN, RU
export const translations = {
  az: {
    nav: {
      home: "Ana səhifə",
      about: "Haqqımızda",
      services: "Xidmətlər",
      projects: "Layihələr",
      process: "Proses",
      why: "Niyə BE1",
      contact: "Əlaqə",
      cta: "Layihə başlat",
    },
    hero: {
      overline: "Software Studio · EST. 2024",
      title: "Gələcəyin rəqəmsal layihələrini BE1 ilə qur",
      subtitle:
        "Biz web tətbiqlər, mobil tətbiqlər, startup MVP-ləri, idarə panelləri və xüsusi proqram həlləri yaradırıq. Sürətli. Premium. Miqyaslanan.",
      ctaPrimary: "Layihələrə bax",
      ctaSecondary: "Əlaqə saxla",
      scroll: "Aşağı sürüşdür",
    },
    about: {
      overline: "Haqqımızda",
      title: "Biz ekranlar üçün deyil, insanlar üçün həllər yaradırıq",
      description:
        "BE1 — müasir rəqəmsal məhsullar, startup layihələri, web saytlar, mobil tətbiqlər və biznes sistemləri yaradan kreativ studiyadır. Hər bir layihəyə premium yanaşma və sürətli icra ilə.",
      stats: [
        { value: "65+", label: "Tamamlanmış layihə" },
        { value: "48+", label: "Aktiv müştəri" },
        { value: "99%", label: "Müştəri məmnuniyyəti" },
        { value: "24/7", label: "Texniki dəstək" },
      ],
      cards: [
        {
          title: "Premium dizayn",
          desc: "Hər piksel düşünülmüş, hər anim hesablanmış. Cinematic təcrübə.",
        },
        {
          title: "Sürətli icra",
          desc: "MVP-lər həftələrlə deyil, günlərlə. Sürət ən böyük rəqabət üstünlüyüdür.",
        },
        {
          title: "Miqyaslanan arxitektura",
          desc: "Bugünkü startup, sabahkı korporasiya. Kod buna hazır olmalıdır.",
        },
      ],
    },
    services: {
      overline: "Nə edirik",
      title: "Premium xidmətlər",
      subtitle: "Konseptdən launch-a qədər tam dövrə dəstək.",
      items: [
        {
          title: "Web Development",
          desc: "React, Next.js və modern stack ilə yüksək performanslı web tətbiqlər.",
        },
        {
          title: "Mobil Tətbiqlər",
          desc: "iOS və Android üçün native təcrübə verən cross-platform tətbiqlər.",
        },
        {
          title: "Startup MVP",
          desc: "Fikirdən launch-a qədər. Sürətli iterasiya və real istifadəçi feedback-i.",
        },
        {
          title: "UI / UX Dizayn",
          desc: "İstifadəçini dəli edən dizayn yox — sevdirən təcrübə.",
        },
        {
          title: "Admin Panelləri",
          desc: "Mürəkkəb məlumatları sadə və estetik dashboard-lara çeviririk.",
        },
        {
          title: "Biznes Avtomatlaşdırma",
          desc: "Manual işləri kəs, gəlirini artır. Workflow və CRM həlləri.",
        },
        {
          title: "SEO Optimallaşdırma",
          desc: "Google-da görünən, sürətli yüklənən və konvertə edən saytlar.",
        },
      ],
    },
    projects: {
      overline: "Seçilmiş işlər",
      title: "Premium layihələr",
      subtitle: "Hər biri unikal problemə fərdi həll.",
      viewProject: "Layihəyə bax",
      items: [
        {
          name: "İmtahan+",
          desc: "Real-time analitika ilə fintech dashboard. 100k+ aktiv istifadəçi.",
          link: "https://imtahanplus.com",
          tech: ["React", "FastAPI", "PostgreSQL", "Redis"],
        },
        {
          name: "Aston Martin",
          desc: "Tibbi randevu və xəstə idarəetmə platforması.",
          tech: ["Next.js", "TypeScript", "Stripe"],
        },
        {
          name: "CashLook",
          desc: "Headless e-ticarət — 3x daha sürətli yüklənmə.",
          link: "https://cashlook.pro",
          tech: ["React", "Shopify", "GraphQL"],
        },
        {
          name: "Tats",
          desc: "B2B satış komandaları üçün AI-əsaslı CRM.",
          link: "https://tats.az",
          tech: ["React", "FastAPI", "OpenAI"],
        },
        {
          name: "Ellasstone",
          desc: "Real-vaxt biznes analitika və BI dashboard.",
          link: "https://ellasstone.com",
          tech: ["React", "D3", "MongoDB"],
        },
        {
          name: "Mobilingo",
          desc: "Logistika şirkəti üçün sürücü tətbiqi.",
          link: "https://apps.apple.com/az/app/mobilingo/id6749503445",
          tech: ["React Native", "FastAPI"],
        },
      ],
    },
    process: {
      overline: "Necə işləyirik",
      title: "İdeyadan launch-a",
      subtitle: "6 mərhələli sınaqdan keçmiş proses.",
      steps: [
        { name: "İdeya", desc: "Konsept, hədəf auditoriya və biznes modelinin formalaşması." },
        { name: "Dizayn", desc: "Wireframe-dən premium UI-yə qədər tam vizual identika." },
        { name: "Development", desc: "Modern stack, təmiz kod, miqyaslanan arxitektura." },
        { name: "Testing", desc: "QA, performans testləri və real istifadəçi feedback-i." },
        { name: "Launch", desc: "Soft launch, marketing dəstəyi və böyümə strategiyası." },
        { name: "Dəstək", desc: "24/7 monitorinq, yeniləmələr və yeni feature-lar." },
      ],
    },
    why: {
      overline: "Niyə BE1",
      title: "Detallarda fərq",
      subtitle: "Bizim üstünlüklərimiz təsadüf deyil.",
      items: [
        { title: "Modern texnologiyalar", desc: "Sənayenin ön cəbhəsindəki stack." },
        { title: "Təmiz kod", desc: "Oxunan, test edilən, sürdürülən." },
        { title: "Sürətli performans", desc: "Core Web Vitals — yaşıl zona." },
        { title: "Responsiv dizayn", desc: "Mobile-first həqiqi yanaşma." },
        { title: "SEO strukturu", desc: "İlk gündən axtarış sistemlərinə hazır." },
        { title: "Miqyaslanan arxitektura", desc: "Bugün 100, sabah 1M istifadəçi." },
        { title: "Fərdi həllər", desc: "Şablon yox — sizin biznes üçün yazılır." },
      ],
    },
    contact: {
      overline: "Əlaqə",
      title: "Gələcəyi birlikdə quraq",
      subtitle:
        "Layihəniz var? Sual var? Aşağıdakı kanallardan istənilən birində bizə yazın — 24 saat ərzində cavab veririk.",
      whatsapp: "WhatsApp",
      instagram: "Instagram",
      email: "Email",
      whatsappValue: "+994 10 525 44 61",
      instagramValue: "@beone.dev",
      emailValue: "info@be1.dev",
    },
    footer: {
      tagline: "Gələcəyin rəqəmsal layihələri.",
      rights: "Bütün hüquqlar qorunur.",
    },
  },

  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      projects: "Projects",
      process: "Process",
      why: "Why BE1",
      contact: "Contact",
      cta: "Start Project",
    },
    hero: {
      overline: "Software Studio · EST. 2024",
      title: "Build the digital future with BE1",
      subtitle:
        "We craft web apps, mobile apps, startup MVPs, dashboards and custom software. Fast. Premium. Scalable.",
      ctaPrimary: "View Projects",
      ctaSecondary: "Get In Touch",
      scroll: "Scroll down",
    },
    about: {
      overline: "About us",
      title: "We don’t build for screens — we build solutions for people",
      description:
        "BE1 is a creative studio building modern digital products, startup projects, websites, mobile apps and business systems — with a premium approach and rapid execution on every engagement.",
      stats: [
        { value: "65+", label: "Projects shipped" },
        { value: "48+", label: "Active clients" },
        { value: "99%", label: "Client satisfaction" },
        { value: "24/7", label: "Technical support" },
      ],
      cards: [
        { title: "Premium design", desc: "Every pixel intentional, every motion measured. Cinematic experience." },
        { title: "Rapid delivery", desc: "MVPs in days, not weeks. Speed is the biggest competitive edge." },
        { title: "Scalable architecture", desc: "Today's startup, tomorrow's enterprise. The code must be ready." },
      ],
    },
    services: {
      overline: "What we do",
      title: "Premium services",
      subtitle: "End-to-end support from concept to launch.",
      items: [
        { title: "Web Development", desc: "High-performance web apps with React, Next.js and a modern stack." },
        { title: "Mobile Apps", desc: "Cross-platform apps that feel native on iOS and Android." },
        { title: "Startup MVP", desc: "From idea to launch. Fast iteration and real user feedback." },
        { title: "UI / UX Design", desc: "Not design that frustrates — experiences that delight." },
        { title: "Admin Dashboards", desc: "We turn complex data into clean, beautiful dashboards." },
        { title: "Business Automation", desc: "Cut manual work, grow revenue. Workflow & CRM solutions." },
        { title: "SEO Optimization", desc: "Sites that rank, load fast and convert." },
      ],
    },
    projects: {
      overline: "Featured work",
      title: "Premium projects",
      subtitle: "Each one a bespoke solution to a unique problem.",
      viewProject: "View project",
      items: [
        { name: "İmtahan+", desc: "Real-time analytics fintech dashboard. 100k+ active users.",link: "https://imtahanplus.com", tech: ["React", "FastAPI", "PostgreSQL", "Redis"] },
        { name: "Aston Martin", desc: "Medical appointment and patient management platform.", tech: ["Next.js", "TypeScript", "Stripe"] },
        { name: "CashLook", desc: "Headless e-commerce — 3× faster page loads.",link: "https://cashlook.pro", tech: ["React", "Shopify", "GraphQL"] },
        { name: "Tats", desc: "AI-driven CRM for B2B sales teams.",link: "https://tats.az", tech: ["React", "FastAPI", "OpenAI"] },
        { name: "Ellasstone", desc: "Real-time business analytics & BI dashboard.",link: "https://ellasstone.com", tech: ["React", "D3", "MongoDB"] },
        { name: "Mobilingo", desc: "Driver app for a logistics company.",link: "https://apps.apple.com/az/app/mobilingo/id6749503445", tech: ["React Native", "FastAPI"] },
      ],
    },
    process: {
      overline: "How we work",
      title: "From idea to launch",
      subtitle: "A proven 6-step process.",
      steps: [
        { name: "Idea", desc: "Concept, target audience and business model definition." },
        { name: "Design", desc: "From wireframe to premium UI — full visual identity." },
        { name: "Development", desc: "Modern stack, clean code, scalable architecture." },
        { name: "Testing", desc: "QA, performance tests and real user feedback." },
        { name: "Launch", desc: "Soft launch, marketing support and growth strategy." },
        { name: "Support", desc: "24/7 monitoring, updates and new features." },
      ],
    },
    why: {
      overline: "Why BE1",
      title: "The difference is in the details",
      subtitle: "Our advantages aren't accidental.",
      items: [
        { title: "Modern technologies", desc: "Front-line industry stack." },
        { title: "Clean code", desc: "Readable, testable, maintainable." },
        { title: "Fast performance", desc: "Core Web Vitals — green zone." },
        { title: "Responsive design", desc: "True mobile-first approach." },
        { title: "SEO structure", desc: "Search-engine ready from day one." },
        { title: "Scalable architecture", desc: "100 today, 1M users tomorrow." },
        { title: "Custom solutions", desc: "No templates — written for your business." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Let's build the future together",
      subtitle:
        "Have a project? A question? Reach out on any channel below — we respond within 24 hours.",
      whatsapp: "WhatsApp",
      instagram: "Instagram",
      email: "Email",
      whatsappValue: "+994 00 000 00 00",
      instagramValue: "@be1.studio",
      emailValue: "info@be1.dev",
    },
    footer: {
      tagline: "Digital projects of the future.",
      rights: "All rights reserved.",
    },
  },

  ru: {
    nav: {
      home: "Главная",
      about: "О нас",
      services: "Услуги",
      projects: "Проекты",
      process: "Процесс",
      why: "Почему BE1",
      contact: "Контакты",
      cta: "Начать проект",
    },
    hero: {
      overline: "Software Studio · EST. 2024",
      title: "Построй цифровое будущее с BE1",
      subtitle:
        "Создаём веб-приложения, мобильные приложения, MVP стартапов, дашборды и кастомное ПО. Быстро. Премиально. Масштабируемо.",
      ctaPrimary: "Смотреть проекты",
      ctaSecondary: "Связаться",
      scroll: "Прокрутите вниз",
    },
    about: {
      overline: "О нас",
      title: "Мы создаём решения не для экранов — а для людей",
      description:
        "BE1 — креативная студия, создающая современные цифровые продукты, стартап-проекты, сайты, мобильные приложения и бизнес-системы. Премиум-подход и быстрая реализация в каждом проекте.",
      stats: [
        { value: "65+", label: "Запущенных проектов" },
        { value: "48+", label: "Активных клиентов" },
        { value: "99%", label: "Удовлетворённость" },
        { value: "24/7", label: "Тех. поддержка" },
      ],
      cards: [
        { title: "Премиум-дизайн", desc: "Каждый пиксель продуман. Кинематографичный опыт." },
        { title: "Быстрая доставка", desc: "MVP за дни, а не недели. Скорость — главное преимущество." },
        { title: "Масштабируемая архитектура", desc: "Сегодня стартап, завтра корпорация. Код должен быть готов." },
      ],
    },
    services: {
      overline: "Что мы делаем",
      title: "Премиум-услуги",
      subtitle: "Полный цикл от концепта до запуска.",
      items: [
        { title: "Web-разработка", desc: "Высокопроизводительные приложения на React, Next.js и современном стеке." },
        { title: "Мобильные приложения", desc: "Кросс-платформенные приложения с нативным ощущением на iOS и Android." },
        { title: "MVP стартапов", desc: "От идеи до запуска. Быстрые итерации и реальная обратная связь." },
        { title: "UI / UX дизайн", desc: "Не раздражающий дизайн — а опыт, который восхищает." },
        { title: "Админ-панели", desc: "Превращаем сложные данные в чистые и красивые дашборды." },
        { title: "Бизнес-автоматизация", desc: "Сокращаем ручную работу, увеличиваем выручку. Workflow и CRM." },
        { title: "SEO-оптимизация", desc: "Сайты, которые ранжируются, быстро грузятся и конвертят." },
      ],
    },
    projects: {
      overline: "Избранные работы",
      title: "Премиум-проекты",
      subtitle: "Каждый — индивидуальное решение уникальной задачи.",
      viewProject: "Открыть проект",
     items: [
  {
    name: "İmtahan+",
    desc: "Финтех-дашборд с real-time аналитикой. 100k+ активных пользователей.",
    link: "https://imtahanplus.com",
    tech: ["React", "FastAPI", "PostgreSQL", "Redis"]
  },
  {
    name: "Aston Martin",
    desc: "Платформа записи и управления пациентами.",
    tech: ["Next.js", "TypeScript", "Stripe"]
  },
  {
    name: "CashLook",
    desc: "Headless e-commerce — в 3 раза быстрее загрузка.",
    link: "https://cashlook.pro",
    tech: ["React", "Shopify", "GraphQL"]
  },
  {
    name: "Tats",
    desc: "CRM с AI для B2B-отделов продаж.",
    link: "https://tats.az",
    tech: ["React", "FastAPI", "OpenAI"]
  },
  {
    name: "Ellasstone",
    desc: "Бизнес-аналитика и BI-дашборд в реальном времени.",
    link: "https://ellasstone.com",
    tech: ["React", "D3", "MongoDB"]
  },
  {
    name: "Mobilingo",
    desc: "Приложение для водителей логистической компании.",
    link: "https://apps.apple.com/az/app/mobilingo/id6749503445",
    tech: ["React Native", "FastAPI"]
  },
],
    },
    process: {
      overline: "Как мы работаем",
      title: "От идеи до запуска",
      subtitle: "Проверенный 6-шаговый процесс.",
      steps: [
        { name: "Идея", desc: "Концепт, целевая аудитория и бизнес-модель." },
        { name: "Дизайн", desc: "От wireframe до премиум-UI — полная визуальная идентичность." },
        { name: "Разработка", desc: "Современный стек, чистый код, масштабируемая архитектура." },
        { name: "Тестирование", desc: "QA, перф-тесты и обратная связь от пользователей." },
        { name: "Запуск", desc: "Soft launch, маркетинг и стратегия роста." },
        { name: "Поддержка", desc: "24/7 мониторинг, обновления и новые фичи." },
      ],
    },
    why: {
      overline: "Почему BE1",
      title: "Разница в деталях",
      subtitle: "Наши преимущества — не случайность.",
      items: [
        { title: "Современные технологии", desc: "Передовой стек индустрии." },
        { title: "Чистый код", desc: "Читаемый, тестируемый, поддерживаемый." },
        { title: "Быстрая производительность", desc: "Core Web Vitals — зелёная зона." },
        { title: "Адаптивный дизайн", desc: "По-настоящему mobile-first." },
        { title: "SEO-структура", desc: "Готов к поиску с первого дня." },
        { title: "Масштабируемая архитектура", desc: "100 сегодня, 1M пользователей завтра." },
        { title: "Кастомные решения", desc: "Никаких шаблонов — пишется под ваш бизнес." },
      ],
    },
    contact: {
      overline: "Контакты",
      title: "Построим будущее вместе",
      subtitle:
        "Есть проект? Вопрос? Свяжитесь по любому каналу ниже — отвечаем в течение 24 часов.",
      whatsapp: "WhatsApp",
      instagram: "Instagram",
      email: "Email",
      whatsappValue: "+994 00 000 00 00",
      instagramValue: "@be1.studio",
      emailValue: "info@be1.dev",
    },
    footer: {
      tagline: "Цифровые проекты будущего.",
      rights: "Все права защищены.",
    },
  },
};
